import { UserManager, WebViewUserManager, IframeUserManager } from '@sravni/utils/lib/auth';
import { AuthType } from '../types/index.js';

const userManager = new UserManager();
const webViewUserManager = new WebViewUserManager();
const iframeUserManager = new IframeUserManager();
const USER_MANAGER_BY_AUTH_TYPE = {
    [AuthType.WebView]: webViewUserManager,
    [AuthType.Default]: userManager,
    [AuthType.Iframe]: iframeUserManager,
};

export { USER_MANAGER_BY_AUTH_TYPE };
//# sourceMappingURL=userManager.js.map
